import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';
import { Constants } from '../../../../shared/const/constants';
import { CmrValidationResult } from '../../../../shared/objects/order/cmrValidationResult';

@Injectable()
export class CmrValidationService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  customerRequiresCmrValidation(customerId: number): Observable<boolean> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<boolean>(
      `${environment.customerServiceUrl}/${customerId}/${Constants.REQUIRES_CMR_VALIDATION_ENDPOINT}`,
      { headers },
    );
  }

  notifyFmsUserOfCmrValidation(orderId: number): Observable<void> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.post<void>(
      `${environment.orderServiceUrl}/${orderId}/${Constants.NOTIFY_FMS_USER_OF_CMR_VALIDATION_ENDPOINT}`,
      null,
      { headers },
    );
  }

  validateCmr(file: File): Observable<CmrValidationResult> {
    const headers = this.authService.getBearerRequestHeaders();
    const data = new FormData();
    data.set('file', file);

    return this.httpClient.post<CmrValidationResult>(
      `${environment.orderServiceUrl}/${Constants.VALIDATE_CMR_ENDPOINT}`,
      data,
      { headers },
    );
  }
}
